module.exports = class Errors {

    /**
     * Create a new Errors instance.
     */
    constructor(data) {
        this.errors = {}
        this.fields = data
        for (let field in this.fields) {
            this[field] = ''
        }
        this.message = '';
        this.exception = '';
    }

    /**
     * Return the first error.
     */
    first() {
        if (this.any()) {
            return this.errors[Object.keys(this.errors)[0]][0];
        }
        if (this.message) return this.message;
        return this.exception;
    }

    /**
     * Determine if an errors exists for the given field.
     */
    has(field) {
        return this.hasOwnProperty(field) && this[field] != '';
    }

    /**
     * Determine if we have any errors.
     */
    any() {
        return this.errors && Object.keys(this.errors).length > 0;
    }

    /**
     * Retrieve the error message for a field.
     */
    get(field) {
        if (this.hasOwnProperty[field]) {
            return this[field][0];
        }
    }

    add(field, message) {
        this[field] = message
    }

    /**
     * Record the new errors.
     */
    record(errors, message, exception = '') {
        for (let error in errors) {
            this[error] = errors[error][0];
        }
        this.errors = errors;
        this.message = message;
        this.exception = exception;
    }

    /**
     * Clear one or all error fields.
     */
    clear(field) {
        if(field && this.hasOwnProperty(field)){
            this[field] = '';
            return
        }
        for (let field in this.fields) {
            this.clear(field)
        }
        this.errors = {}
        this.message = ''
        this.exception = ''
    }

    static newBag(errors) {
        var bag = new Errors;
        bag.record(errors.hasOwnProperty('errors') ? error.errors : {}, errors.message, errors.exception);
        return bag;
    }
}
